import React, { useEffect } from "react";
import { useState } from "react";
import { Form, Button, Row, InputGroup, Card, Spinner } from "react-bootstrap";
import trayaLogo1 from "../../../src/assets/img/illustrations/starfleet_light.png";
import LoginWithGoogle from "./LoginWithGoogle";
import { baseURL } from "./../../config/index";
import { ENV } from "../../config/env";
import { useNavigate } from "react-router-dom";
import Toaster from "modules/navbar/Toaster";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useSetUserDetails, userLoginStore } from "./store/store";
import { validateUrl } from "modules/utilities/utility_2";
import { Switch } from "antd";

function Login() {
  const { setToaster, title, message, variant } = useToast();
  const { API_URL_BASE } = baseURL;
  const { fetchLoginData, isLoading, res, forgotPassword } = userLoginStore();
  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [form, setForm] = useState("login");
  const { setUserDetails } = useSetUserDetails();
  const [trayaEmployee, setTrayaEmployee] = useState(ENV === 'dev' ? true : false);

  useEffect(() => {
    if (window.location.pathname !== "/login") {
      navigate("/login");
    }
  }, [navigate]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    fetchLoginData(
      email,
      password,
      setToaster,
      setUserDetails,
      navigate,
      validateUrl
    );
    setValidated(true);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  useEffect(() => {
    if (res === 200) {
      setTimeout(() => {
        setForm("login");
      }, 3000);
    }
  }, [res]);

  const onChange = (checked) => {
    setTrayaEmployee(checked);
  };


  return (
    <div
      className="container-fluid d-flex flex-column justify-content-center align-items-center vh-100"
      style={{ backgroundColor: "rgb(235,235,235)" }}
    >
      <div className="top-0 d-flex justify-content-center">
        <Toaster title={title} variant={variant} message={message} />
      </div>
      <Card className="w-100 bg-rgb(239,239,239)" style={{ maxWidth: "30rem" }}>
        <Card.Header className="d-flex justify-content-center align-items-center ">
          <div className="circle-container">
            <div
              className="text-white d-flex align-items-center justify-content-center"
              style={{
                display: "inline-block",
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                overflow: "hidden",
                backgroundColor: "black",
              }}
            >
              <img
                style={{ width: "8rem", filter: "brightness(0) invert(1)" }}
                src={trayaLogo1}
              />
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          {ENV === 'prod' && (
            <div className="d-flex gap-2 align-items-center w-75">
              <div className="p-1 fw-bold text-primary">External Employee :</div>
              <Switch onChange={onChange} />
            </div>
          )}
          <Form noValidate validated={validated}>
            {trayaEmployee ? (
              form === "login" ? (
                <>
                  <Row className="mb-3">
                    <Form.Group md="5" controlId="exampleUserName">
                      <Form.Label className="">Username</Form.Label>
                      <InputGroup hasValidation>
                        <Form.Control
                          name="email"
                          type="email"
                          placeholder="Username"
                          aria-label="Username"
                          aria-describedby="inputGroupPrepend"
                          required
                          value={email}
                          onChange={handleEmailChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please choose a username.
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3 mt-4">
                    <Form.Group md="4" controlId="exampleCity">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="Password"
                        required
                        value={password}
                        onChange={handlePasswordChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter a valid password.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <div className="d-flex gap-5">
                    <Button
                      onClick={handleSubmit}
                      className="mt-4 float-end btn-success d-flex gap-2"
                      style={{ backgroundColor: "rgb(98,141,18)" }}
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading && <Spinner animation="border" size="sm" />}
                      <span className="fs-1">Login</span>
                    </Button>
                    <a
                      href="#"
                      className="mt-4 float-end fw-bold text-primary"
                      style={{
                        padding: "10px 20px",
                        textDecoration: "none",
                      }}
                      onClick={() => {
                        setForm("");
                      }}
                    >
                      Forget Password
                    </a>
                  </div>
                  {ENV === 'prod' && (
                    <>
                      <hr />
                      <div className="d-flex justify-content-center mt-5">
                        <LoginWithGoogle />
                      </div>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Row className="mb-3">
                    <Form.Group md="5" controlId="exampleUserName">
                      <InputGroup hasValidation>
                        <Form.Control
                          name="email"
                          type="email"
                          placeholder="Username"
                          aria-label="Username"
                          aria-describedby="inputGroupPrepend"
                          required
                          value={email}
                          onChange={handleEmailChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter appropriate email.
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </Row>
                  <Row className="text-center d-flex justify-content-around p-2">
                    <Button
                      variant="success"
                      className="w-25"
                      onClick={() => {
                        forgotPassword(email, setToaster);
                      }}
                    >
                      Submit
                    </Button>
                  </Row>
                </>
              )
            ) : ENV === 'prod' ? (
              <>
                <div className="d-flex justify-content-center mt-5">
                  <LoginWithGoogle />
                </div>
              </>
            ) : null}
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Login;
